export function formatTime(dateString, format = 'full') {
  const date = new Date(dateString);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  if (format === 'time') {
    return `${hours}:${minutes}`;
  }

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}